import { getSocket } from '@src/App';

export default async (gameId: string, cardId: string) => {
  try {
    getSocket().emit('playCard', { gameId, cardId });
  } catch (e) {
    console.log(e);
  }
};
